import React from 'react'

const CreateGroup = () => {
  return (
    <div className="not-found">
    <h1 style={{color:'red'}}>Coming soon</h1>
  </div>
  )
}

export default CreateGroup
